import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import AdminDashboard from "@/pages/AdminDashboard";
import PartnersAdmin from "@/pages/PartnersAdmin";
import ContestDetail from "@/pages/ContestDetail";
import KioskLanding from "@/pages/KioskLanding";
import KioskGame from "@/pages/KioskGame";
import StatsDashboard from "@/pages/StatsDashboard";
import PrintGuide from "@/pages/PrintGuide";
import VerifyReceipt from "@/pages/VerifyReceipt";
import StoresAdmin from "@/pages/StoresAdmin";
import AuditLog from "@/pages/AuditLog";
import CampaignsPage from "@/pages/CampaignsPage";
import DisplayScreen from "@/pages/DisplayScreen";
import LoginPage, { AuthCallback, ProtectedRoute, ForgotPasswordPage, ResetPasswordPage } from "@/pages/LoginPage";
import Landing from "@/pages/Landing";
import HostRoot from "@/components/HostRoot";
import HomePage from "@/pages/HomePage";
import DemoRequestsPage from "@/pages/DemoRequestsPage";
import SupportInboxPage from "@/pages/SupportInboxPage";
import TestimonialsAdmin from "@/pages/TestimonialsAdmin";
import StudioSettings from "@/pages/StudioSettings";
import { useAuth } from "@/lib/auth";
import BatchDelivery from "@/pages/BatchDelivery";
import UnifiedLogin from "@/pages/UnifiedLogin";
import { AuthProvider } from "@/lib/auth";
import { CustomerProvider } from "@/lib/customer";
import CustomerLogin, { CustomerAuthCallback } from "@/pages/CustomerLogin";
import ContestLogin from "@/pages/ContestLogin";
import PublicContests from "@/pages/PublicContests";
import MyPrizes from "@/pages/MyPrizes";
import ReceiptUpload from "@/pages/ReceiptUpload";
import PublicDraw from "@/pages/PublicDraw";
import CustomersAdmin from "@/pages/CustomersAdmin";
import PublicRules from "@/pages/PublicRules";
import PublicPrivacy from "@/pages/PublicPrivacy";
import CookieBanner from "@/components/CookieBanner";

const P = ({ children, adminOnly, perm }) => <ProtectedRoute adminOnly={adminOnly} perm={perm}>{children}</ProtectedRoute>;

function RootGate() {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen bg-background" data-testid="root-gate-loading" />;
  return user ? <AdminDashboard /> : <HomePage />;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return location.pathname.includes("/accedi") ? <CustomerAuthCallback /> : <AuthCallback />;
  return (
    <Routes>
      <Route path="/concorsi" element={<PublicContests />} />
      <Route path="/accedi" element={<CustomerLogin />} />
      <Route path="/i-miei-premi" element={<MyPrizes />} />
      <Route path="/scontrino/:id" element={<ReceiptUpload />} />
      <Route path="/estrazione/:token" element={<PublicDraw />} />
      <Route path="/login" element={<UnifiedLogin />} />
      <Route path="/consegna/:batchId" element={<BatchDelivery />} />
      <Route path="/c/:slug" element={<Landing />} />
      <Route path="/c/:slug/accedi" element={<ContestLogin />} />
      <Route path="/admin-login" element={<LoginPage />} />
      <Route path="/password-dimenticata" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/" element={<HostRoot fallback={<RootGate />} />} />
      <Route path="/concorso/:id" element={<P adminOnly><ContestDetail /></P>} />
      <Route path="/statistiche" element={<P><StatsDashboard /></P>} />
      <Route path="/guida-stampa" element={<P perm="print"><PrintGuide /></P>} />
      <Route path="/sedi" element={<P perm="stores"><StoresAdmin /></P>} />
      <Route path="/log-attivita" element={<P perm="audit"><AuditLog /></P>} />
      <Route path="/clienti" element={<P perm="customers"><CustomersAdmin /></P>} />
      <Route path="/campagne" element={<P perm="whatsapp"><CampaignsPage /></P>} />
      <Route path="/verifica" element={<VerifyReceipt />} />
      <Route path="/gioca" element={<KioskLanding />} />
      <Route path="/gioca/:id" element={<KioskGame />} />
      <Route path="/online/:id" element={<KioskGame />} />
      <Route path="/widget/:id" element={<KioskGame />} />
      <Route path="/partner" element={<P><PartnersAdmin /></P>} />
      <Route path="/embed/:id" element={<KioskGame />} />
      <Route path="/display/:id" element={<DisplayScreen />} />
      <Route path="/regolamento/:id" element={<PublicRules />} />
      <Route path="/privacy/:id" element={<PublicPrivacy />} />
      <Route path="/privacy" element={<PublicPrivacy />} />
      <Route path="/richieste-demo" element={<P adminOnly><DemoRequestsPage /></P>} />
      <Route path="/support" element={<P adminOnly><SupportInboxPage /></P>} />
      <Route path="/testimonianze" element={<P adminOnly><TestimonialsAdmin /></P>} />
      <Route path="/contatti-studio" element={<P adminOnly><StudioSettings /></P>} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <CustomerProvider>
          <AppRouter />
          <CookieBanner />
        </CustomerProvider>
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
